export const INCOTERM_SHOW_RESET = 'INCOTERM_SHOW_RESET'
export const INCOTERM_SHOW_SET_ERROR = 'INCOTERM_SHOW_SET_ERROR'
export const INCOTERM_SHOW_SET_RETRIEVED = 'INCOTERM_SHOW_SET_RETRIEVED'
export const INCOTERM_SHOW_TOGGLE_LOADING = 'INCOTERM_SHOW_TOGGLE_LOADING'
